<template>
    <div
        v-if="docCodeList.length !== 0"
        style="display: flex; align-items: center; margin-right: -6px;">

        <slot
            :name="['dropdown-btn', docCodeList[0]].join('-')"
            v-if="docCodeList.length === 1"
        >

        </slot>

        <v-menu
            v-else
            v-model="doc"
            class="menu-settings menu-doc"
            :bottom="bottom"
            :top="!bottom"
            :nudge-top="nudgeTop"
        >
            <v-btn
                flat
                :ripple="false"
                slot="activator"
                :class="activatorBtnClass"
            >
                    <span class="color-headings-text">{{text("api.doc")}}</span>
                    <arrow-down-icon v-if="!doc" :height="24" :width="24" />
                    <arrow-up-icon v-else :width="24" :height="24"/>
            </v-btn>
            <v-card>
                <v-list class="elevation-bg-color">
                    <v-list-tile :key="code" v-for="code in docCodeList">
                        <slot :name="['dropdown-btn', code].join('-')">

                        </slot>
                    </v-list-tile>
                </v-list>
            </v-card>
        </v-menu>
    </div>
</template>

<script>
import ArrowUpIcon from "../svg/shared/arrowUpIcon";
import ArrowDownIcon from "../svg/shared/arrowDownIcon";
export default {
    name: "DocDropdown",
    components: {ArrowDownIcon, ArrowUpIcon},
    props: {
        docCodeList: {
            type: Array,
            required: true,
            default: []
        },
        bottom: {
            type: Boolean,
            required: false,
            default: true,
        },
        nudgeTop: {
            type: Number,
            required: false,
            default: -40,
        },
        activatorBtnClass: {
            type: String,
            required: false,
            default: 'btn-menu dropdown-btn-menu'
        },
    },

    data() {
        return {
            doc: false,
        };
    },
}
</script>



// WEBPACK FOOTER //
// src/common/components/shared/DocDropdown.vue